import resources from "./locales";
import i18n from "@izi-logistics/common/lib/i18n";
export default i18n.init(resources);
